import { Col, Row, Spin } from 'antd'
import { Button, EmptyScreen } from 'modules/core/components'
import {
  ApplicationHistoricalDrawer,
  ApplicationManualCreation,
  CreateApplicationModal,
  GlobalBudgetSACDetail,
  GlobalBudgetSACList,
} from './components'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import emptyStateImage from 'assets/images/compositions/empty-big.svg'
import planning from 'modules/planning'
import { useTranslation } from 'react-i18next'
import configuration from 'modules/configuration'
import login from 'modules/login'

const GlobalBudgetSAC = ({
  fetchAdjustments,
  adjustmentsList,
  fetchApplicationDetail,
  applicationDetail,
  downloadApplicationDetailXLS,
  fetchAdjustmentsKpis,
  adjustmentsKpis,
  fetchAreasList,
  areaList,
  fetchAllDimensions,
  fetchAllDimensionsValues,
  allDimensionsList,
  loggedUser: { pkid },
}) => {
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [showManualCreation, setShowManualCreation] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [showDrowerHistorical, setShowDrowerHistorical] = useState(false)
  const [rowId, setRowId] = useState(null)
  const [showDetail, setShowDetail] = useState(false)
  const [detailLoading, setDetailLoading] = useState(false)
  const [isKpisLoading, setIsKpisLoading] = useState(false)
  const [activeStatusFilter, setActiveStatusFilter] = useState(null)
  const [activeSearchId, setActiveSearchId] = useState(null)
  const [isMyPending, setIsMyPending] = useState(false)
  const [societyOptions, setSocietyOptions] = useState([])
  const [activeSocietyIds, setActiveSocietyIds] = useState([])
  const [activeAdjustmentTypes, setActiveAdjustmentTypes] = useState([])
  const { t } = useTranslation()
  let { globalBudgetId, periodId } = useParams()

  var queryString = window.location.search
  var urlParams = new URLSearchParams(queryString)
  var applicationId = urlParams.get('applicationId')

  useEffect(() => {
    window.history.replaceState(
      null,
      '',
      `/planificacion/${periodId}/presupuestoglobal/${globalBudgetId}/sac`,
    )
  }, [periodId, globalBudgetId])

  useEffect(() => {
    setIsLoading(true)
    fetchAdjustments({ projection: globalBudgetId, module: 'OVERALL_PLANNING' }).then(() =>
      setIsLoading(false),
    )
  }, [fetchAdjustments, globalBudgetId])

  useEffect(() => {
    setIsKpisLoading(true)
    fetchAdjustmentsKpis({ projection: globalBudgetId, module: 'OVERALL_PLANNING' }).then(() =>
      setIsKpisLoading(false),
    )
  }, [fetchAdjustmentsKpis, globalBudgetId])

  useEffect(() => {
    if (rowId) {
      setDetailLoading(true)
      fetchApplicationDetail({ adjustment_id: rowId }).then(() => setDetailLoading(false))
    }
  }, [fetchApplicationDetail, rowId])

  useEffect(() => {
    if (pkid) {
      fetchAreasList({ user_id: pkid })
    }
  }, [fetchAreasList, pkid])

  useEffect(() => {
    if (applicationId) {
      setRowId(applicationId)
      setShowDetail(true)
    }
  }, [applicationId])

  useEffect(() => {
    fetchAllDimensions()
  }, [fetchAllDimensions])

  const societyDimension = allDimensionsList.find((dimension) => {
    const dimensionName = dimension?.name_destination?.toLowerCase()
    return dimensionName === 'sociedad' || dimensionName === 'society'
  })

  useEffect(() => {
    if (societyDimension?.id) {
      fetchAllDimensionsValues({ id_dimension: societyDimension.id }).then((response) => {
        setSocietyOptions(
          response.payload.data
            .filter(
              (dimensionValue) =>
                !dimensionValue.name_destination?.toLowerCase().includes('valor sin asignar'),
            )
            .map((dimensionValue) => ({
              ...dimensionValue,
              name: dimensionValue.name_destination,
              code: dimensionValue.code_destination,
            })),
        )
      })
    }
  }, [fetchAllDimensionsValues, societyDimension?.id])

  const refetch = (statusFilter, searchId, myPending, societyIds, adjustmentTypes) => {
    setIsLoading(true)
    setActiveStatusFilter(statusFilter || null)
    setActiveSearchId(searchId || null)
    setIsMyPending(myPending || false)
    const nextSocietyIds = societyIds === undefined ? activeSocietyIds : societyIds
    const nextAdjustmentTypes =
      adjustmentTypes === undefined ? activeAdjustmentTypes : adjustmentTypes
    setActiveSocietyIds(nextSocietyIds)
    setActiveAdjustmentTypes(nextAdjustmentTypes)
    const params = { projection: globalBudgetId, module: 'OVERALL_PLANNING' }
    if (statusFilter) params.status = statusFilter
    if (searchId) params.id = searchId
    if (myPending) params.my_pending = true
    if (nextSocietyIds.length) params.society = nextSocietyIds.join(',')
    if (nextAdjustmentTypes.length) params.adjustment_type = nextAdjustmentTypes.join(',')
    fetchAdjustments(params).then(() => {
      setIsLoading(false)
    })
  }

  const hasActiveFilter =
    activeStatusFilter ||
    activeSearchId ||
    isMyPending ||
    activeSocietyIds.length > 0 ||
    activeAdjustmentTypes.length > 0
  const showList = adjustmentsList.length > 0 || hasActiveFilter

  return (
    <>
      {!showManualCreation && (
        <Spin spinning={isLoading}>
          <Row gutter={[24, 24]}>
            {!showList && (
              <Col span={24}>
                <EmptyScreen
                  image={emptyStateImage}
                  description={t('PLANNING_SAC_EMPTY_SCREEN_DESCRIPTION')}
                  footer={
                    <Button.Primary
                      disabled={areaList.length === 0}
                      title="ACTION_CREATE_NEW"
                      onClick={() => setShowCreateModal(true)}
                      tooltipTitle={
                        areaList.length === 0
                          ? t('PLANNING_SAC_INFORMATIVE_CREATE_AREAS_TOOLTIP_TITLE')
                          : ''
                      }
                    />
                  }
                />
              </Col>
            )}
            {showList && (
              <>
                {!showDetail && (
                  <GlobalBudgetSACList
                    isKpisLoading={isKpisLoading}
                    adjustmentsKpis={adjustmentsKpis}
                    adjustmentsList={adjustmentsList}
                    onClickDetail={(id) => {
                      setShowDetail(true)
                      setRowId(id)
                    }}
                    onClickHistorical={(id) => {
                      setShowDrowerHistorical(true)
                      setRowId(id)
                    }}
                    onClickCreate={() => setShowCreateModal(true)}
                    onRefetch={refetch}
                    onRefetchKpis={() =>
                      fetchAdjustmentsKpis({
                        projection: globalBudgetId,
                        module: 'OVERALL_PLANNING',
                      })
                    }
                    activeStatusFilter={activeStatusFilter}
                    activeSearchId={activeSearchId}
                    isMyPending={isMyPending}
                    activeSocietyIds={activeSocietyIds}
                    activeAdjustmentTypes={activeAdjustmentTypes}
                    societyOptions={societyOptions}
                    areaList={areaList}
                  />
                )}
                {showDetail && (
                  <GlobalBudgetSACDetail
                    applicationDetail={applicationDetail}
                    detailLoading={detailLoading}
                    onDownload={() => downloadApplicationDetailXLS(rowId)}
                    onReturn={() => {
                      setShowDetail(false)
                      setRowId(null)
                    }}
                  />
                )}
              </>
            )}
          </Row>
          <ApplicationHistoricalDrawer
            visible={showDrowerHistorical}
            onClose={() => setShowDrowerHistorical(false)}
            rowId={rowId}
          />
        </Spin>
      )}
      {showManualCreation && (
        <ApplicationManualCreation
          onRefetch={refetch}
          onReturn={() => setShowManualCreation(false)}
        />
      )}
      <CreateApplicationModal
        visible={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onRedirect={() => setShowManualCreation(true)}
        onRefetch={refetch}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  adjustmentsList: planning.selectors.getAdjustmentsList(state),
  applicationDetail: planning.selectors.getApplicationDetail(state),
  adjustmentsKpis: planning.selectors.getAdjustmentsKpis(state),
  areaList: configuration.selectors.getAreaList(state),
  allDimensionsList: configuration.selectors.getAllDimensionsList(state),
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  fetchAdjustments: planning.actions.fetchAdjustments,
  fetchApplicationDetail: planning.actions.fetchApplicationDetail,
  downloadApplicationDetailXLS: planning.actions.downloadApplicationDetailXLS,
  fetchAdjustmentsKpis: planning.actions.fetchAdjustmentsKpis,
  fetchAreasList: configuration.actions.fetchAreasList,
  fetchAllDimensions: configuration.actions.fetchAllDimensions,
  fetchAllDimensionsValues: configuration.actions.fetchAllDimensionsValues,
}

export default connect(mapStateToProps, mapDispatchToProps)(GlobalBudgetSAC)
